import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  Grid,
  Typography,
} from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core/styles';
import { deleteButtonColor, textColor } from '../../sub-components/colors/colors';
import { environment } from '../../../environments/environment';

export function DeletePrivilege(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const deletePrivilege = async (id) => {
    setLoading(true);

    try {
      const response = await fetch(`${environment.host}/ums/super/user-privilege/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
        },
      });

      const data = await response.json();

      if (data.message === 'Success') {
        props.setSeverity('success');
        props.setTopic('Success');
        props.setMessage('Privilege deleted successfully');
        props.setAlertOpen(true);
        props.onClose();
        props.getPrivileges();
        setTimeout(() => props.setAlertOpen(false), 4000);
      } else {
        props.setSeverity('error');
        props.setTopic('Error');
        props.setMessage(data.message);
        props.setAlertOpen(true);
        props.onClose();
        setTimeout(() => props.setAlertOpen(false), 3000);
      }
    } catch (error) {
      console.error('Error deleting privilege:', error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const hasChildren = props.privilege.child && props.privilege.child.length > 0;

  return (
    <Dialog open={props.open} maxWidth="md" className={classes.dialogOverlay}>
      <Grid item xs={12} md={12} style={{ padding: '20px' }}>
        <Typography>
          Do you really want to delete the privilege with name {props.privilege.name}?
        </Typography>
        {hasChildren && (
          <Typography style={{ marginTop: '10px', color: 'red' }}>
            This privilege has sub-privileges. Deleting it will also remove all its sub-privileges.
          </Typography>
        )}
      </Grid>
      <DialogActions style={{ width: '100%', justifyContent: 'right', marginTop: '10px' }}>
        <Button variant="contained" className={classes.cancel} onClick={props.onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          className={classes.delete}
          onClick={() => deletePrivilege(props.privilege.id)}
          disabled={loading}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 9999,
      '& .MuiBackdrop-root': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
      },
      '& .MuiPaper-root': {
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
      },
    },
    delete: {
      backgroundColor: deleteButtonColor,
      color: 'white',
      marginBottom: '10px',
      marginRight: '10px',
      width: '20%',
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
    },
    cancel: {
      backgroundColor: 'white',
      color: textColor,
      marginBottom: '10px',
      marginRight: '10px',
      width: '20%',
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
    },
  })
);
